<form
  (ngSubmit)="submit()"
  class="flex flex-col">
  <label for="new-password">Choose a password</label>
  <div class="relative max-w-[320px]">
    <input
      [type]="showPassword() ? 'text' : 'password'"
      id="new-password"
      autocomplete="new-password"
      [formField]="passwordResetForm.password"
      class="pr-9!" />
    @if (passwordResetForm.password().errors()) {
      @for (error of passwordResetForm.password().errors(); track error.kind) {
        @if (error.kind === 'weakPassword') {
          <p>{{ error.message }}</p>
        }
      }
    }
    <button
      type="button"
      (click)="togglePassword()"
      class="absolute top-1 right-1 flex h-7 w-7 items-center justify-center border-0 bg-transparent"
      [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
      <i [class]="showPassword() ? 'icon-view' : 'icon-hidden'"></i>
    </button>
  </div>
  <label for="confirm-password">Confirm password</label>
  <div class="relative max-w-[320px]">
    <input
      [type]="showPassword() ? 'text' : 'password'"
      id="confirm-password"
      autocomplete="new-password"
      [formField]="passwordResetForm.passwordConfirmation"
      class="pr-9!" />
    <button
      type="button"
      (click)="togglePassword()"
      class="absolute top-1 right-1 flex h-7 w-7 items-center justify-center border-0 bg-transparent"
      [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
      <i [class]="showPassword() ? 'icon-view' : 'icon-hidden'"></i>
    </button>
  </div>
  <button
    uiBtn
    btnType="submit"
    [primary]="true"
    [disabled]="!passwordResetToken()"
    [loading]="submitting()">
    Set my password
  </button>
</form>
